export default class CustomReplaceMenu {
  constructor(popupMenu, bpmnReplace) {
    popupMenu.registerProvider("bpmn-replace", this);
    this.replaceElement = bpmnReplace.replaceElement;
  }

  getPopupMenuHeaderEntries(element) {
    function hideLoopEntries(entries) {
      let loopEntries = [/* "toggle-parallel-mi", "toggle-sequential-mi", "toggle-addhoc", "toggle-loop"*/];
      for (const p of loopEntries) {
        if (entries[p]) {
          delete entries[p];
        }
      }
    }
    return function (headerEntries) {
      hideLoopEntries(headerEntries);
      return headerEntries;
    };
  }

  getPopupMenuEntries(element) {
    function removeUnwantedItems(entries) {
      let unwanted = [
        // "replace-with-none-start",
        // "replace-with-none-end",
        "replace-with-none-intermediate-throwing",
        "replace-with-message-intermediate-throw",
        "replace-with-message-start",
        "replace-with-timer-start",
        "replace-with-conditional-start",
        "replace-with-signal-start",
        "replace-with-message-intermediate-catch",
        "replace-with-message-end",
        "replace-with-escalation-end",
        "replace-with-error-end",
        "replace-with-cancel-end",
        "replace-with-compensation-end",
        "replace-with-signal-end",
        "replace-with-terminate-end",
        // "replace-with-exclusive-gateway",
        // "replace-with-parallel-gateway",
        // "replace-with-inclusive-gateway",
        "replace-with-complex-gateway",
        "replace-with-event-based-gateway",
        // "replace-with-task",
        // "replace-with-user-task",
        "replace-with-service-task",
        "replace-with-send-task",
        "replace-with-receive-task",
        "replace-with-manual-task",
        "replace-with-rule-task",
        "replace-with-script-task",
        "replace-with-call-activity",
        "replace-with-collapsed-subprocess",
        "replace-with-expanded-subprocess",
        "replace-with-message-boundary",
        "replace-with-timer-boundary",
        "replace-with-escalation-boundary",
        "replace-with-conditional-boundary",
        "replace-with-error-boundary",
        "replace-with-signal-boundary",
        "replace-with-compensation-boundary",
        "replace-with-non-interrupting-message-boundary",
        "replace-with-non-interrupting-timer-boundary",
        "replace-with-non-interrupting-escalation-boundary",
        "replace-with-non-interrupting-conditional-boundary",
        "replace-with-non-interrupting-signal-boundary",
        "replace-with-none-intermediate-throw",
        "replace-with-escalation-intermediate-throw",
        "replace-with-compensation-intermediate-throw",
        "replace-with-error-intermediate-throw",
        "replace-with-signal-intermediate-throw",
        "replace-with-link-intermediate-catch",
        "replace-with-link-intermediate-throw",
        "replace-with-none-intermediate-catch",
        "replace-with-timer-intermediate-catch",
        "replace-with-conditional-intermediate-catch",
        "replace-with-signal-intermediate-catch"
      ];
      for (const p of unwanted) {
        delete entries[p];
      }
    }

    // const self = this;
    return function (entries) {
      // To add extra options
      // if (isAny(element, ["bpmn:StartEvent"])) {
      //   entries = {
      //     ...entries,
      //     "replace-with-conditional-start": {
      //       label: "Conditional Start Event",
      //       className: "bpmn-icon-start-event-condition",
      //       action: function () {
      //         return self.replaceElement(element, {
      //           type: "bpmn:StartEvent",
      //           eventDefinitionType: "bpmn:ConditionalEventDefinition"
      //         });
      //       }
      //     }
      //   };
      // }
      removeUnwantedItems(entries);
      return entries;
    };
  }
}

CustomReplaceMenu.$inject = ["popupMenu", "bpmnReplace"];
